// Оболочка любого экрана раздела карт.
//
// Своего поля света здесь больше нет: оно одно на всё приложение и живёт в
// App.js. Раньше свет был только тут, потому что стекло было только тут.
// Осталась геометрия: экран во весь рост, со своей шапкой и закреплённым
// снизу действием.
const CardsScene = ({ className = "", children, testId }) => (
  <div
    className={`relative flex h-[100dvh] min-h-[100dvh] flex-col overflow-hidden text-foreground ${className}`}
    data-testid={testId}
  >
    {children}
  </div>
);

export default CardsScene;
